import React from 'react';
import PropTypes from 'prop-types';
import {Alert, Box} from '@tenancy.nz/ui';

function Error({content = undefined}) {
  if (!content) {
    return null;
  }
  return (
    <Box mb={5}>
      <Alert variant="standard" color="error">
        {content}
      </Alert>
    </Box>
  );
}

Error.propTypes = {
  content: PropTypes.node,
};

export default Error;
